module.exports = "<div class=\"alert alert-danger\" role=\"alert\"><span class=\"ni ni-exclamation-circle\"></span> <%=message%></div>\n"